import { orderBy, isEmpty } from 'lodash'

export default {
    GET_DASHBOARD_ITEM_REQUEST: (state, data) => {
        if (data.codeName === 'paperNeededReport') {
            state.paperNeededLoading = true
        }
        if (data.codeName === 'userTasksNotFinished') {
            state.userTasksLoading = true
        }
        if (data.codeName === 'ordersProcesses') {
            state.ordersProcessesLoading = true
        }
        if (data.codeName === 'processedOrders') {
            state.processedOrdersLoading = true
        }
        if (data.codeName === 'newOrders') {
            state.newOrdersLoading = true
        }
    },
    GET_DASHBOARD_ITEM_FAILURE: (state, data) => {
        if (data.codeName === 'paperNeededReport') {
            state.paperNeededLoading = false
        }
        if (data.codeName === 'ordersProcesses') {
            state.ordersProcessesLoading = true
        }
        if (data.codeName === 'processedOrders') {
            state.processedOrdersLoading = true
        }
        if (data.codeName === 'newOrders') {
            state.newOrdersLoading = true
        }
    },
    GET_ORDERS_PRODUCTS_PER_DAY_NOT_SENT: (state, data) => {
        state.ordersProductsPerDayNotSent = data.results
    },
    GET_ORDERS_PRODUCTS_DELAYED: (state, data) => {
        state.ordersProductsDelayed = data.results
    },
    GET_DASHBOARD_ITEM_SUCCESS: (state, data) => {
        if (data.codeName === 'paperNeededReport') {
            state.paperNeeded = data.body.data.results
            state.paperNeededLoading = false
        }
        if (data.codeName === 'userTasksNotFinished') {
            state.userTasks = data.body.data.results
            state.userTasksLoading = false
        }
        if (data.codeName === 'machineReview') {
            state.machinesDashboard = data
        }
        if (data.codeName === 'ordersProcesses') {
            state.ordersProcesses = data.body.content
            state.ordersProcessesLoading = false
        }
        if (data.codeName === 'processedOrders') {
            state.processedOrders = data.body.content
            state.processedOrdersLoading = false
        }
        if (data.codeName === 'newOrders') {
            state.newOrders = data.body.content
            state.newOrdersLoading = false
        }
        if (data.codeName === 'numberOfOrdersPerImposition') {
            state.numberOfOrdersPerImposition = data.body.data
        }
    },
    SET_DASHBOARD_ITEMS: (state, dashboardItem) => {
        if (!isEmpty(dashboardItem.body)) {
            state.dashboardItems.push(dashboardItem)
            state.dashboardItems = orderBy(state.dashboardItems, 'position', 'asc')
        }
    },
    GET_DASHBOARD_SECTIONS: (state, data) => {
        state.dashboardSections = data
    },
    SET_DASHBOARD_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_DASHBOARD_ITEMS: state => {
        state.dashboardItems = []
    },
    CLEAR_DASHBOARD_FILTERS: state => {
        state.filters = state.setInitialFilters()
    },
    SET_MACHINES_DASHBOARD: (state, data) => {
        state.hasMachinesDashboard = true
        state.machinesDashboard = data
    },
    SAVE_PAGINATION: (state, data) => {
        state.pagination = data.pagination
        state.paginationSettings = data.paginationSettings
    }
}